module.exports = "<label class=\"file-label\">Envoyer un fichier</label>\r\n<input type=\"file\" (change)=\"fileChange($event)\" placeholder=\"Upload file\" accept=\".pdf,.doc,.docx\">\r\n<p *ngIf=\"uploadingFile\" class=\"spinner-block\"><i class=\"fa fa-spinner fa-spin\" aria-hidden=\"true\"></i></p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/file-upload/file-upload.component.html
// module id = ./src/app/shared/file-upload/file-upload.component.html
// module chunks = main